/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Attribute { 
    name?: string;
    type?: Attribute.TypeEnum;
    multiValued?: boolean;
    required?: boolean;
    caseExact?: boolean;
    mutability?: Attribute.MutabilityEnum;
    returned?: Attribute.ReturnedEnum;
    uniqueness?: Attribute.UniquenessEnum;
    referenceTypes?: Array<string>;
    canonicalValues?: Set<string>;
    description?: string;
    subAttributes?: Array<Attribute>;
}
export namespace Attribute {
    export const TypeEnum = {
        Binary: 'binary',
        Boolean: 'boolean',
        Complex: 'complex',
        DateTime: 'dateTime',
        Decimal: 'decimal',
        Integer: 'integer',
        Reference: 'reference',
        String: 'string'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
    export const MutabilityEnum = {
        Immutable: 'immutable',
        ReadOnly: 'readOnly',
        ReadWrite: 'readWrite',
        WriteOnly: 'writeOnly'
    } as const;
    export type MutabilityEnum = typeof MutabilityEnum[keyof typeof MutabilityEnum];
    export const ReturnedEnum = {
        Always: 'always',
        Default: 'default',
        Never: 'never',
        Request: 'request'
    } as const;
    export type ReturnedEnum = typeof ReturnedEnum[keyof typeof ReturnedEnum];
    export const UniquenessEnum = {
        Global: 'global',
        None: 'none',
        Server: 'server'
    } as const;
    export type UniquenessEnum = typeof UniquenessEnum[keyof typeof UniquenessEnum];
}


